import { ListTonesDto } from '../../../dto/listtones/listtonesdto';
import { APIRequest, APIRequestDtoImpl } from '../../apiRequest';

export interface ListTonesRequest extends APIRequest
{
    getListTonesRequest(): ListTonesDto;
}

export class ListTonesRequestImpl extends APIRequestDtoImpl implements ListTonesRequest
{
    constructor(private getListTonesData: ListTonesDto)
    {
        super();
    }

    getListTonesRequest(): ListTonesDto
    {
        return this.getListTonesData;
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/mytunes/listtones/listtonesrequest.tsx